import { Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchNodes } from "../redux/nodesSlice";

function PostDirectory({ post, sx }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { nodesIndex, status } = useSelector((state) => state.nodes);

  const path = post.numberedPath || post.path;
  let displayPath = t("unknown");

  if (post.fullDirectory) {
    displayPath = post.fullDirectory;
  } else if (post.directoryName) {
    displayPath = post.directoryName;
  } else if (path && nodesIndex) {
    const node = nodesIndex[path];
    if (node && node.name) {
      displayPath = node.name;
    } else if (post.name) {
      displayPath = post.name;
    } else {
      const segments = path.split(".").filter(Boolean);
      if (segments.length === 1 && path === "001") {
        displayPath = t("all"); // Special case for root node
      } else if (segments.length > 0) {
        displayPath = `...${segments[segments.length - 1]}`;
      } else {
        displayPath = path;
      }
    }
  } else if (post.name) {
    displayPath = post.name;
  }

  useEffect(() => {
    if (
      !post.directoryName &&
      !post.fullDirectory &&
      path &&
      (!nodesIndex || Object.keys(nodesIndex).length === 0) &&
      status === "idle"
    ) {
      dispatch(fetchNodes({ path: "root" }));
    }
  }, [
    path,
    nodesIndex,
    status,
    dispatch,
    post.directoryName,
    post.fullDirectory,
  ]);

  return (
    <Typography sx={sx} my={0.5}>
      {displayPath}
    </Typography>
  );
}

export default PostDirectory;
